document.addEventListener("DOMContentLoaded", async () => {
  const product = window.meta?.product || Shopify?.product;
  if (!product) {
    console.warn("[FREE GIFT] No product object found.");
    return;
  }

  // Only Breville
  const isBreville = product?.vendor?.toLowerCase().includes("breville");
  if (!isBreville) return;

  // Load free gift text
  const giftDataEl = document.querySelector("script[data-free-gift]");
  const giftData = giftDataEl ? JSON.parse(giftDataEl.textContent) : {};
  const texts = giftData?.["free-gift"] || {};

  /* -------------------------------------------------------
     PRICE LOGIC (FIXED FOR DISCOUNTED PRODUCTS)
  ------------------------------------------------------- */

  const variant = product?.variants?.[0];

  const actualPrice = Number(variant?.price) / 100 || 0;

  // Treat compare-at price only if it exists and > 0
  const comparePriceRaw = Number(variant?.compare_at_price);
  const comparePrice =
    comparePriceRaw && comparePriceRaw > 0 ? comparePriceRaw / 100 : null;

  // The logic: use whichever price is HIGHER when compare price exists
  const priceForTier =
    comparePrice !== null ? Math.max(actualPrice, comparePrice) : actualPrice;

  console.log("[FREE GIFT] Actual price:", actualPrice);
  console.log("[FREE GIFT] Compare price:", comparePrice);
  console.log("[FREE GIFT] Price used:", priceForTier);

  let tier = 0;

  // New tier rules (compare OR actual qualifies)
  if (priceForTier >= 1599.99) tier = 3;
  else if (priceForTier >= 649.99) tier = 2;
  else if (priceForTier >= 449.99) tier = 1;

  // EXTRA FIX: discounted Breville products still qualify
  if (tier === 0 && actualPrice >= 349.99 && actualPrice <= 449.98) {
    console.log("[FREE GIFT] Discounted Breville detected → force Tier 1");
    tier = 1;
  }

  console.log("[FREE GIFT] FINAL TIER:", tier);

  if (tier === 0) return;

  /* -------------------------------------------------------
     GIFT PRODUCT HANDLES
  ------------------------------------------------------- */
  const giftHandlesByTier = {
    1: ["colosseo-2", "godshot-2", "holycow-2", "zen-decaf"],
    2: ["colosseo-2", "godshot-2", "holycow-2", "zen-decaf"],
    3: ["colosseo-2", "godshot-2", "holycow-2", "zen-decaf"]
  };

  /* -------------------------------------------------------
     FETCH GIFTS
  ------------------------------------------------------- */
  async function fetchGifts(handles) {
    const products = await Promise.all(
      handles.map(handle =>
        fetch(`/products/${handle}.js`)
          .then(res => (res.ok ? res.json() : null))
          .catch(() => null)
      )
    );

    return products
      .filter(Boolean)
      .map(p => ({
        title: p.title,
        image: p.images?.[0],
        variantId: p.variants?.[0]?.id
      }));
  }

  const giftProducts = await fetchGifts(giftHandlesByTier[tier]);
  if (!giftProducts.length) return;

  /* -------------------------------------------------------
     BUILD GIFT UI
  ------------------------------------------------------- */
  function buildGiftUI(index = 1) {
    const div = document.createElement("div");
    div.className = `free-gift-cart-block gift-form-${index}`;
    div.style.display = "none";
    div.style.opacity = "1";
    div.style.transition = "opacity 0.4s ease";

    div.innerHTML = `
      <div class="free-gift-wrapper" style="background:#f5f1ed;padding:24px;border-radius:8px;margin:16px 0;display:flex;gap:16px;">
        <div class="free-gift-image" style="position:relative;width:120px;flex-shrink:0;">
          <span style="position:absolute;top:-8px;left:-8px;background:#e63946;color:white;padding:4px 12px;font-size:12px;font-weight:bold;border-radius:4px;">GRATUIT</span>
          <img src="${giftProducts[0].image}" alt="${giftProducts[0].title}" style="width:100%;height:auto;">
        </div>
        <div class="free-gift-content" style="flex:1;">
          <h3 style="margin:0 0 8px;font-size:18px;font-weight:bold;">${texts.cart_gift_title}</h3>
          <p style="margin:0 0 16px;font-size:14px;color:#666;">${texts.cart_gift_text}</p>

          <select class="gift-select-product" style="width:100%;padding:10px;border-radius:4px;margin-bottom:12px;">
            ${giftProducts
        .map(p => `<option value="${p.variantId}">${p.title}</option>`)
        .join("")}
          </select>

          <select class="gift-select-grind" style="width:100%;padding:10px;border-radius:4px;margin-bottom:16px;">
            <option value="Aucune mouture / No grind">Aucune mouture / No grind</option>
            <option value="Espresso">Espresso</option>
            <option value="Moka Pot">Moka Pot</option>
            <option value="Aeropress">Aeropress</option>
            <option value="Filter">Filtre</option>
          </select>

          <button class="add-gift-btn" style="width:100%;background:#1a1a1a;color:white;padding:12px;border:none;border-radius:4px;font-weight:600;text-transform:uppercase;">
            ${texts.cart_gift_button}
          </button>
        </div>
      </div>
    `;

    // Add gift listener
    div.querySelector(".add-gift-btn").addEventListener("click", async () => {
      const variantId = div.querySelector(".gift-select-product").value;
      const grind = div.querySelector(".gift-select-grind").value;

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: { Grind: grind, _free_gift: "true" }
              }
            ]
          })
        });

        div.style.opacity = "0";
        div.dataset.giftHidden = "true";
        setTimeout(() => div.remove(), 450);

        document.dispatchEvent(new CustomEvent("cart:refresh"));
      } catch (err) {
        console.error("[FREE GIFT] Error adding gift:", err);
      }
    });

    return div;
  }

  const giftForms = Array.from({ length: tier }, (_, i) =>
    buildGiftUI(i + 1)
  );

  /* -------------------------------------------------------
     OBSERVER
  ------------------------------------------------------- */
  const observer = new MutationObserver(() => {
    const container = document.querySelector(".cart-drawer__items");
    if (!container) return;

    giftForms.forEach(form => {
      if (form.dataset.giftHidden === "true") return;

      if (!container.contains(form)) {
        container.appendChild(form);
      }

      form.style.display = "block";
      form.style.opacity = "1";
    });

    // Keep observing until every gift has been claimed, so the surviving
    // forms get re-injected each time the cart drawer re-renders on refresh.
    const allGiftsClaimed = giftForms.every(
      form => form.dataset.giftHidden === "true"
    );

    if (allGiftsClaimed) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
